import {
  Box,
  FormHelperText,
  Grid,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { appImages } from "../../assets";
import AppLoader from "../../components/apploader";
import GlobalButton from "../../components/button";
import InputField from "../../components/InputField";
import SuggestedDestinations from "../../components/NavBar/locationSearch";
import CustomSelect from "../../components/select";
import theme from "../../components/theme";
import useCategories from "../../hooks/useCategories";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { sendWaitlistRequest } from "../../services/authenticationFn";
import { getServiceSubCategories } from "../../services/categoriesFn";
import { joinWaitlistValidation } from "../../utils/validation";
import Select from "react-select";

let subRoles = [
  {
    label: "Cleaning Service",
    value: "6746e890abfebd01600040e0",
  },
  {
    label: "Car Services",
    value: "6746e8dfabfebd01600040e8",
  },
  {
    label: "Product Supplier",
    value: "3",
  },
];
const JoinWaitlist = () => {
  const { categoriesLoading, allCategories } = useCategories();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [inputValues, setInputValues] = useState({
    name: "",
    email: "",
    userType: "",
    service: "",
    subService: [],
    individual: "",
    location: "",
  });
  const [inputError, setInputError] = useState({
    name: false,
    email: false,
    userType: false,
    service: false,
    subService: false,
    location: false,
    individual: false,
    isEmailValid: false,
  });

  const handleChangeInputs = (event) => {
    const { name, value } = event.target;
    setInputError((err) => ({
      ...err,
      [name]: false,
      isEmailValid: name === "email" ? false : inputError.isEmailValid,
    }));
    setInputValues((val) => ({ ...val, [name]: value }));
  };

  const handleGetSubCategories = async (event) => {
    let valuee = event.target.value;
    setInputValues({
      ...inputValues,
      service: valuee,
      subService: [],
    });
    setInputError((err) => ({
      ...err,
      service: false,
    }));
    if (valuee !== "Product Supplier") {
      setIsLoading(true);
      try {
        let objjjj = subRoles.find((itemmmmm) => itemmmmm.label == valuee);
        let resultt = await getServiceSubCategories(objjjj.value);
        setIsLoading(false);
        if (resultt.status == 200 || resultt.status == 201)
          setSubCategories(resultt.data.data);
        else setSubCategories([]);
      } catch (error) {
        setIsLoading(false);
      }
    }
  };

  const handleJoinWaitlist = async () => {
    try {
      const validate = joinWaitlistValidation(inputValues, setInputError);
      if (validate) return;

      let newArrr = inputValues.subService.map((itemmm) => itemmm.label);
      let payload = {
        ...inputValues,
        subService: newArrr,
      };

      setIsLoading(true);
      const response = await sendWaitlistRequest(payload);
      if (response.data.status === "success") {
        showSnackbar(response.data.message, "success");
        setTimeout(() => {
          navigate("/");
        }, 1000);
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  let arrayToMap =
    inputValues.service == ""
      ? []
      : inputValues.service == "Product Supplier"
      ? allCategories.map((itemmmm) => {
          return { label: itemmmm.name, value: itemmmm._id };
        })
      : subCategories.map((itemmmm) => {
          return { label: itemmmm.name, value: itemmmm._id };
        });

  return (
    <Box
      sx={{
        backgroundImage: `url(${appImages.waitlistBgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        // backgroundImage: theme.palette.text.chinesePurple,
        minHeight: "100vh",
        padding: "60px 0 24px",
      }}
    >
      <AppLoader isVisible={isLoading || categoriesLoading} />
      <Grid
        container
        spacing={2}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid item xs={11} sm={8} md={5}>
          <Box
            sx={{ background: "#fff", padding: "24px", borderRadius: "20px" }}
          >
            <Stack textAlign={"center"}>
              <Typography
                variant="body1"
                color={theme.palette.text.chinesePurple}
                fontWeight={700}
                fontSize={32}
                marginBottom={"10px"}
              >
                Be the First to Experience EaziDay!
              </Typography>
              <Typography variant="heading_sec" color={"black"}>
                Join the waitlist to get early access and exclusive benefits.
              </Typography>
            </Stack>

            <Grid container rowSpacing={2} mt={3}>
              <Grid item xs={12}>
                <InputField
                  required
                  inputError={inputError.name}
                  helperText={inputError.name ? "Name is required" : null}
                  placeholder={"Enter your name"}
                  name={"name"}
                  value={inputValues.name}
                  onChange={handleChangeInputs}
                />
              </Grid>
              <Grid item xs={12}>
                <InputField
                  required
                  inputError={inputError.email || inputError.isEmailValid}
                  helperText={
                    inputError.email
                      ? "Email address is required"
                      : inputError.isEmailValid
                      ? "Invalid email format"
                      : null
                  }
                  placeholder={"Enter email address"}
                  type={"email"}
                  name={"email"}
                  value={inputValues.email}
                  onChange={handleChangeInputs}
                />
              </Grid>
              <Grid xs={12} mt={2}>
                <CustomSelect
                  name="userType"
                  value={inputValues.userType}
                  onChange={handleChangeInputs}
                  selectError={inputError.userType}
                  helperText={inputError.userType && "User type is required"}
                  formStyleProps={{
                    "& .MuiSelect-outlined": { padding: "8px !important" },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        overflowY: "auto", // make sure the menu scrolls
                      },
                    },
                  }}
                >
                  <MenuItem value={""} disabled>
                    Select User Type
                  </MenuItem>
                  {[
                    {
                      label: "I am a Client",
                      value: "client",
                    },
                    {
                      label: "I am a Service Provider",
                      value: "serviceProvider",
                    },
                  ].map((stateObj) => (
                    <MenuItem key={stateObj.label} value={stateObj.value}>
                      {stateObj.label}
                    </MenuItem>
                  ))}
                </CustomSelect>
              </Grid>
              <Grid xs={12} mt={2}>
                <CustomSelect
                  name="service"
                  value={inputValues.service}
                  onChange={(eee) => handleGetSubCategories(eee)}
                  selectError={inputError.service}
                  helperText={inputError.service && "Service Type is required"}
                  formStyleProps={{
                    "& .MuiSelect-outlined": { padding: "8px !important" },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        overflowY: "auto", // make sure the menu scrolls
                      },
                    },
                  }}
                >
                  <MenuItem value={""} disabled>
                    Select Service Type
                  </MenuItem>
                  {subRoles.map((stateObj) => (
                    <MenuItem key={stateObj.value} value={stateObj.label}>
                      {stateObj.label}{" "}
                      {inputValues.userType == "client"
                        ? ""
                        : stateObj.value !== "3"
                        ? "Provider"
                        : ""}
                    </MenuItem>
                  ))}
                </CustomSelect>
              </Grid>
              <Grid xs={12} mt={2}>
                <Select
                  defaultValue={inputValues.subService}
                  isMulti
                  name="colors"
                  options={arrayToMap}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Category"
                  value={inputValues.subService}
                  isClearable={false} // Clearable only if non-fixed options exist
                  onChange={(valueee) => {
                    setInputValues({
                      ...inputValues,
                      subService: valueee,
                    });
                    setInputError({
                      ...inputError,
                      subService: false,
                    });
                  }}
                />
                {inputError.subService && (
                  <FormHelperText sx={{ color: "red" }}>
                    Category is required
                  </FormHelperText>
                )}
                {/* <CustomSelect
                  name="subService"
                  value={inputValues.subService}
                  onChange={handleChangeInputs}
                  selectError={inputError.subService}
                  helperText={inputError.subService && "Category is required"}
                  formStyleProps={{
                    "& .MuiSelect-outlined": { padding: "8px !important" },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        overflowY: "auto", // make sure the menu scrolls
                      },
                    },
                  }}
                >
                  <MenuItem value={""} disabled>
                    Select Category
                  </MenuItem>
                  {arrayToMap.map((stateObj) => (
                    <MenuItem
                      key={stateObj._id}
                      value={stateObj.name}
                      sx={{ textTransform: "capitalize" }}
                    >
                      {stateObj.name}
                    </MenuItem>
                  ))}
                </CustomSelect> */}
              </Grid>
              <Grid xs={12} mt={2}>
                <CustomSelect
                  name="individual"
                  value={inputValues.individual}
                  onChange={handleChangeInputs}
                  selectError={inputError.individual}
                  helperText={
                    inputError.individual && "Select You are individual/company"
                  }
                  formStyleProps={{
                    "& .MuiSelect-outlined": { padding: "8px !important" },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        overflowY: "auto", // make sure the menu scrolls
                      },
                    },
                  }}
                >
                  <MenuItem value={""} disabled>
                    You Are?
                  </MenuItem>
                  {[
                    {
                      label: "Individual",
                      value: "individual",
                    },
                    {
                      label: "Company",
                      value: "company",
                    },
                  ].map((stateObj) => (
                    <MenuItem
                      key={stateObj.label}
                      value={stateObj.label}
                      sx={{ textTransform: "capitalize" }}
                    >
                      {stateObj.label}
                    </MenuItem>
                  ))}
                </CustomSelect>
              </Grid>
              <Grid xs={12} mt={2}>
                <SuggestedDestinations
                  selectError={inputError.location}
                  helperText={inputError.location && "Location is required"}
                  onLocationSelect={(valueee) => {
                    setInputValues({
                      ...inputValues,
                      location: valueee,
                    });
                    setInputError((err) => ({
                      ...err,
                      location: false,
                    }));
                  }}
                />
              </Grid>
            </Grid>

            <GlobalButton
              btnText={"Join the Waitlist"}
              handleClickBtn={handleJoinWaitlist}
              styleProps={{
                width: "100%",
                height: 50,
                mt: 4,
                fontSize: "1.125rem",
              }}
            />

            <Typography color={"black"} textAlign={"center"} marginTop={"20px"}>
              🚀 Launching Soon in Romania, Germany, France, Spain & Italy
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default JoinWaitlist;
